// extracted by mini-css-extract-plugin
module.exports = {"currency":"Table-styles-module--currency--V12yS","flexwrap":"Table-styles-module--flexwrap--3yDY8"};